export default __webpack_public_path__ + "cloud-storage-uploading-option.png";